import { Component, Inject, ChangeDetectionStrategy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { FieldsSettings } from './add-field-filter.interface';

@Component({
  selector: 'app-add-field-filter',
  templateUrl: './add-field-filter.component.html',
  styleUrl: './add-field-filter.component.scss',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class AddFieldFilterComponent {
  public fieldsSettings: FieldsSettings[] = [];

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<AddFieldFilterComponent>,
  ) {
    this.fieldsSettings = this.data.data.fieldsSettings;
  }

  save(): void {
    const selectedFields = this.fieldsSettings.filter((field) => field.checked);

    this.dialogRef.close({ selectedFields });
  }

  cancel(): void {
    this.dialogRef.close();
  }

  protected readonly Object = Object;
}
